const getUrlParam = function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 

    var r = window.location.search.substr(1).match(reg); 
    if (r != null) 
    	return decodeURIComponent(r[2]); 
    return null; 
}

//编写公共的方法，在main.js里面引入，并且配置到vue的属性上
const arrExit=function(arr,arrItem){
	var isExit=false;
	for(var i=0;i<arr.length;i++){
		if(arr[i]==arrItem){
			isExit=true;
			break;
		}
	}
	return isExit;
}

//把毫秒转成具体的年月日，时分秒
 
const format = function(date,format) {
	var o = {
		"M+" : date.getMonth() + 1,
		"d+" : date.getDate(),
		"h+" : date.getHours(),
		"m+" : date.getMinutes(),
		"s+" : date.getSeconds(),
		"q+" : Math.floor((date.getMonth() + 3) / 3),
		"S" : date.getMilliseconds()
	};
	if (/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
		}
	}
	return format;
};
const getFormatDateByLong=function(l, pattern) {
	return getFormatDate(new Date(l), pattern);
}
const getSmpFormatDate=function(date, isFull) {
	var pattern = "";
	if (isFull == true || isFull == undefined) {
		pattern = "yyyy-MM-dd hh:mm:ss";
	} else {
		pattern = "yyyy-MM-dd";
	}
	return getFormatDate(date, pattern);
}

const getFormatDate=function(date, pattern) {
	if (date == undefined) {
		date = new Date();
	}
	if (pattern == undefined) {
		pattern = "yyyy-MM-dd hh:mm:ss";
	}
	return format(date,pattern);
}

//设置cookie,放在main.js

const setCookie = function(c_name,value,expiredays) {
  var exdate=new Date()
  exdate.setDate(exdate.getDate()+expiredays)
  document.cookie=c_name+ "=" +escape(value)+
    ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
};


//获取cookie

const getCookie=function(c_name) {
  if (document.cookie.length>0)
  {
    var  c_start=document.cookie.indexOf(c_name + "=")
    if (c_start!=-1)
    {
      c_start=c_start + c_name.length+1
     var c_end=document.cookie.indexOf(";",c_start)
      if (c_end==-1) c_end=document.cookie.length
      return unescape(document.cookie.substring(c_start,c_end))
    }
  }
  return ""
};
export default{
	arrExit,
	getFormatDateByLong,
	setCookie,
	getCookie,
	getUrlParam
}


//////////////////
// WEBPACK FOOTER
// ./script/commonMethods.js
// module id = bfxX
// module chunks = 16